import React from "react";
import Popover from "@mui/material/Popover";

export default function CustomPopover({ dialog, anchorEl, handlePopover, content }) {
  if (dialog.open)
    return (
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={dialog.open}
        hideBackdrop={false}
        onClose={() => handlePopover({ type: "cancel" })}
      >
        {content()}
      </Popover>
    );
  return <div></div>;
}
